<template>
  <c-loading-area :loading="receipt === null">
    <template #default>
      <v-card-title>
        {{ $t('page.receiptDetails.title') }}
      </v-card-title>
      <v-card-subtitle>
        {{ $t('page.receiptDetails.subtitle') }}
      </v-card-subtitle>
      <v-card-text class="pt-2 pb-6">
        <dl class="d-grid grid-4060">
          <dt>{{ $t('receipt.referenceNumber') }}</dt>
          <dd>{{ receipt.referenceNumber }}</dd>
          <dt>{{ $t('receipt.receiptType') }}</dt>
          <dd>{{ receipt.receiptType.displayName }}</dd>
          <dt>{{ $t('receipt.receiptDate') }}</dt>
          <dd>{{ receipt.receiptDate | formatDateTime }}</dd>
          <dt>{{ $t('receipt.processorTransactionNumber') }}</dt>
          <dd>{{ receipt.processorTransactionNumber }}</dd>
          <template v-if="!isNil(receipt.user)">
            <dt>{{ $t('receipt.userID') }}</dt>
            <dd>{{ receipt.user.actor.displayName }}</dd>
          </template>
          <template v-if="!isNil(receipt.organization)">
            <dt>{{ $t('receipt.organizationID') }}</dt>
            <dd>{{ receipt.organization.sortName }}</dd>
          </template>
          <template v-if="showGuestPayor">
            <dt>{{ $t('receipt.userID') }}</dt>
            <dd>{{ $t('global.guestPayor') }}</dd>
          </template>
          <dt>{{ $t('receipt.receiptStatus.short') }}</dt>
          <dd>{{ receipt.receiptStatus.displayName }}</dd>
          <dt>{{ $t('receipt.amount') }}</dt>
          <dd>{{ receipt.amount | formatCurrency }}</dd>
        </dl>
      </v-card-text>
    </template>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    receipt: {
      type: Object
    }
  },
  computed: {
    showGuestPayor () {
      return _.isNil(this.receipt.user) && _.isNil(this.receipt.organization);
    }
  }
};
</script>